import React from 'react';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { WorkerListCard } from './WorkerListCard';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../../shared/utils/CardStorageManager';

export class WorkerListScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_WORKERS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MIS_TRABAJADORES_PARA_MIS_CONTRATISTAS')} breadcrumbs={breadcrumbs}>
                <WorkerListCard
                    storageManager={this.cardStorageManager}
                />
            </PsPage>
        );
    }

    saveCardState = (state) => {
        this.cardStorageManager.saveCard('myWorkers', state);
    };

    readCardState = () => {
        return this.cardStorageManager.readCard('myWorkers');
    };
}

WorkerListScreen.propTypes = {};

WorkerListScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/list/WorkerListScreen.jsx